import api from '../../../lib/api';
import type { InfoAssetPayload, InfoAssetSummary, PaginatedInfoAssets } from './types';

export interface ListInfoAssetsParams {
  page?: number;
  pageSize?: number;
  type?: string;
  classification?: string;
  status?: string;
  search?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export const fetchInfoAssets = async (
  params: ListInfoAssetsParams = {},
): Promise<PaginatedInfoAssets> => {
  const { data } = await api.get<PaginatedInfoAssets>('info-assets', { params });
  return data;
};

export const fetchInfoAsset = async (id: string): Promise<InfoAssetSummary> => {
  const { data } = await api.get<InfoAssetSummary>(`info-assets/${id}`);
  return data;
};

export const createInfoAsset = async (payload: InfoAssetPayload) => {
  const { data } = await api.post('info-assets', payload);
  return data;
};

export const updateInfoAsset = async (id: string, payload: Partial<InfoAssetPayload>) => {
  const { data } = await api.put(`info-assets/${id}`, payload);
  return data;
};

export const deactivateInfoAsset = async (id: string) => {
  const { data } = await api.delete(`info-assets/${id}`);
  return data;
};
